import React from 'react';
import { Checkbox, Divider, message, Typography } from 'antd';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { updateEmailPreference } from '../../services';
import AccountDetails from './helpers/AccountDetails';
import PasswordReset from './helpers/PasswordReset';
import ProfileAvatarUploader from './helpers/ProfileAvatarUploader';
import { usePasswordReset } from './helpers/usePasswordReset';
import './userProfile.scss';

const { Title } = Typography;

const UserProfile: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.user);
  const passwordReset = usePasswordReset(user?.email);

  const handleEmailPreferenceChange = async (checked: boolean) => {
    if (!user?.id) {
      return;
    }

    try {
      await dispatch(
        updateEmailPreference({
          userId: user.id,
          marketingEmailsOptIn: checked,
        })
      ).unwrap();
      message.success('Email preferences updated.');
    } catch (error) {
      message.error(typeof error === 'string' ? error : 'Failed to update email preferences.');
    }
  };

  return (
    <div className="user-profile">
      <Title level={2}>My Account</Title>
      <Divider />

      <Title level={4}>Settings & Preferences</Title>
      <ProfileAvatarUploader user={user} />
      <AccountDetails user={user} />

      <Divider />

      <Title level={5}>Email Preferences:</Title>
      <Checkbox
        checked={Boolean(user?.marketingEmailsOptIn)}
        onChange={(event) => handleEmailPreferenceChange(event.target.checked)}
      >
        Send me news updates and offers.
      </Checkbox>

      <Divider />

      <PasswordReset email={user?.email || ''} passwordReset={passwordReset} />
    </div>
  );
};

export default UserProfile;
